<template>
    <div class="container page">
        <van-nav-bar :title="$t('hc')" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" color="#000000" @click="back()" />
            </template>
        </van-nav-bar>
        <div style="height:54px;"></div>
        <div class="list-wrap">
            <!-- 列表项 -->
            <a class="list-item">
                {{ $t('成人用品') }}
            </a>
        </div>
        <div class="list-wrap2">
            <div class="boxs" v-for="(item, index) in datalist2" :key="index">
                <img :src="$imgSrc(item.img_url)" alt="">
                <div class="t">{{ item.xuanfei_name }}</div>
                <div class="text" @click="toUrl('/Lottery')">{{ $t('立即获取') }}</div>
            </div>
        </div>
        <div
            style="width: 96%;background: #F75796;padding: 15px;border-radius: 8px;margin: 0 auto;margin-bottom: 20px;">
            <div style="color: #fff;font-size: 14px;">{{ $t('HowToObtain') }}</div>
            <div style="color: #fff;font-size: 14px;margin-left: 20px;">{{ $t('sjzp') }}</div>
        </div>
        <div class="list-wrap">
            <!-- 列表项 -->
            <a class="list-item">
                {{ $t('幸运礼物') }}
            </a>
        </div>
        <div class="list-wrap2">
            <div class="boxs" v-for="(item, index) in datalist" :key="index">
                <img :src="$imgSrc(item.img_url)" alt="">
                <div class="t">{{ item.xuanfei_name }}</div>
                <div class="text" @click="toUrl('/Lottery')">{{ $t('立即获取') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            datalist: [],
            datalist2: [],
            isLoading: true
        }
    },
    methods: {
        toUrl(url) {
            this.$router.push(url)
        },
        back() {
            this.$router.back()
        },
    },
    mounted() {

        this.$http({
            method: "get",
            url: "xuanfeilist",
            data: { 'home_class': 4 },
        }).then((res) => {
            // const lanng = localStorage.getItem("lang");
            // console.log(res, 'res')
            this.datalist = res.data;
            this.isLoading = false
        })
        this.$http({
            method: "get",
            url: "xuanfeilist",
            data: { 'home_class': 3 },
        }).then((res) => {
            // const lanng = localStorage.getItem("lang");
            console.log(res, 'res')
            this.datalist2 = res.data;
            this.isLoading = false
        })
    }
}
</script>


<style scoped lang="less">
.container {
    position: relative;
    width: 100%;
    height: fit-content;
    min-height: 100dvh;
    background: #f2f2f5 url('../../assets/image/bgj.png') no-repeat center top / 100%;
    padding: 0 10px;
}

.nav-bar {
    background: #f2f2f5 url('../../assets/image/bgj.png') no-repeat center top / 100% auto;
}

::v-deep .van-nav-bar__title {
    color: #000 !important;
}

.list-wrap {
    width: 100%;
    padding: 15px;
}

.list-item,
.list-wrap2 {
    display: flex;
    align-items: center;
    padding: 20px 16px;
    gap: 12px;
    background: linear-gradient(30deg, #d63f8c, #7d76ef);
    border-radius: 10px;
    margin-bottom: 20px;
    color: #fff;
    font-size: 24px;
}

.list-wrap2 {
    padding: 15px;
    background: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;

    .boxs {
        width: calc(50% - 10px);
        position: relative;
        margin-bottom: 20px;
        height: 300px;

        img {
            display: block;
            width: 100%;
            height: 300px;
            object-fit: fill;
        }

        .t {
            color: #000;
            font-size: 24px;
            margin: 20px 0px;
        }

        .text {
            background: linear-gradient(30deg, #d63f8c, #7d76ef);
            color: #fff;
            padding: 14px;
            border-radius: 30px;
            text-align: center;
        }
    }
}

.item-logo {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* logo */
.item-logo img {
    width: 60px;
    height: 60px;
    border-radius: 6px;
    object-fit: cover;
}

/* 中间名称：自动占剩余宽度，文字溢出省略 */
.item-name {
    flex: 1;
    color: #ffffff;
    font-size: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 右侧弹性布局 */
.item-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.item-info {
    font-size: 28px;
    color: #fff;
}

.avatar img {
    width: 62px;
    height: 62px;
    border-radius: 4px;
    object-fit: cover;
}

.arrow {
    font-size: 18px;
    color: #c8c9cc;

    .iconfont {
        font-size: 24px;
        color: #000;
    }
}
</style>